const DEFAULT_API_ENDPOINT = 'https://1704m2sq0f.execute-api.us-east-1.amazonaws.com/v1';
const apiEndpoint = (process.env.REACT_APP_API_ENDPOINT || DEFAULT_API_ENDPOINT).replace(/\/$/, '');

const parseResponse = async (response) => {
  // Some upload failures return an empty or XML response.
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(body.error || 'The feedback service is unavailable.');
  }
  return body;
};

export const uploadScreenshot = async (file) => {
  const uploadResponse = await fetch(`${apiEndpoint}/feedback/upload-url`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contentType: file.type,
      size: file.size,
    }),
  });
  const { screenshotKey, upload } = await parseResponse(uploadResponse);

  const uploadBody = new FormData();
  Object.entries(upload.fields).forEach(([name, value]) => {
    uploadBody.append(name, value);
  });
  uploadBody.append('file', file);

  const screenshotResponse = await fetch(upload.url, {
    method: 'POST',
    body: uploadBody,
  });
  if (!screenshotResponse.ok) {
    throw new Error('The screenshot could not be uploaded.');
  }

  return screenshotKey;
};

export const submitFeedback = async (feedback) => {
  const response = await fetch(`${apiEndpoint}/feedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(feedback),
  });
  return parseResponse(response);
};
